import { floatToRatio, isObj } from '@/utils/tools'
// import { h, render, Transition } from 'vue'
// import Loading from '@/components/Loading.vue'
// 注册全局指令

export default function (Vue) {
    //注册全局聚焦指令: v-focus
    Vue.directive('focus', {
        mounted(el) {
            el.focus()
        },
    })
    Vue.directive('riseFall', {
        bind(el, binding) {
            const classList = ['rise', 'fall', 'flat']
            let value = '',
                params = {}
            if (isObj(binding.value)) {
                const { rate = true, toFixed = true, base = 2, sign = true, pow = 0 } = binding.value
                value = binding.value.value
                params = { rate, toFixed, base, sign, pow }
            } else {
                value = binding.value
            }
            const text = floatToRatio(value, params)
            const className = value > 0 ? 'rise' : value < 0 ? 'fall' : 'flat'
            el.innerText = text
            classList.forEach(name => {
                el.classList.remove(name)
            })
            el.classList.add(className)
        },
        update(el, binding) {
            const classList = ['rise', 'fall', 'flat']
            let value = '',
                params = {}
            if (isObj(binding.value)) {
                const { rate = true, toFixed = true, base = 2, sign = true, pow = 0 } = binding.value
                value = binding.value.value
                params = { rate, toFixed, base, sign, pow }
            } else {
                value = binding.value
            }
            const text = floatToRatio(value, params)
            const className = value > 0 ? 'rise' : value < 0 ? 'fall' : 'flat'
            el.innerText = text
            classList.forEach(name => {
                el.classList.remove(name)
            })
            el.classList.add(className)
        },
    })

    // 多行文案处理
    Vue.directive('multiRows', {
        inserted(el, binding) {
            const singleLineHeight = Number(el.dataset.lineHeight) || 16
            const rowNum = Math.ceil(el.offsetHeight / singleLineHeight)

            if (el.offsetHeight > singleLineHeight) {
                if (binding.value instanceof Function) {
                    binding.value(rowNum)
                } else if (typeof binding.value === 'string') {
                    el.classList.add(binding.value)
                }
            }

            el.classList.add(`multi-row-${rowNum}`)
        },
    })

    // Vue.directive('clickoutside', {
    //     // 初始化指令
    //     bind(el, binding) {
    //         function handler(e) {
    //         // 这里判断点击的元素是否是本身，是本身，则返回
    //         if (el.contains(e.target)) {
    //             return false;
    //         }
    //         let isReturn = false
    //         binding.arg.map(item => {
    //             if (document.querySelector('#'+item).contains(e.target)) {
    //                 isReturn = true
    //             }
    //         })
    //         if (isReturn) {
    //             return false
    //         }
    //         // 判断指令中是否绑定了函数
    //         if (binding.expression) {
    //             // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
    //             binding.value(e);
    //         }
    //         }
    //         // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    //         el.__vueClickOutside__ = handler;
    //         document.addEventListener('click', handler);
    //     },
    //     update() {},
    //     unbind(el) {
    //         // 解除事件监听
    //         document.removeEventListener('click', el.__vueClickOutside__);
    //         delete el.__vueClickOutside__;
    //     },
    // })

    /*注册加载遮罩指令: v-loading 适用任何dom节点
    v-loading.fullscreen 指令参数fullscreen 是否全屏显示
    props:
    @loading-type icon类型 circular||spinner
    @loading-size icon大小
    @loading-color icon及文字颜色
    @loading-textsize 文字字号大小
    @loading-vertical Boolean icon及文字对齐方式
    @loading-background 遮罩背景色
    @loading-text 加载显示文字
    */
    // Vue.directive('loading', {
    //     mounted(el, binding, vnode) {
    //         el.loading = function(vnode){
    //             var get = (key) => vnode.props[`loading-${key}`]
    //             var _loading = h(Loading, { size: get('size'), color: get('color'), type: get('type'), textSize: get('textsize'), vertical: get('vertical'), bgColor: get('background'), fixed: binding.modifiers.fullscreen ? true : false }, { default: () => get('text') })
    //             return _loading
    //         }
    //         el.transition = (child) => h(Transition, {
    //             'enter-active-class': 'animated short fadeIn', 'leave-active-class': 'animated short fadeOut', onAfterLeave: () => {
    //                 var _classname = el.className.split(' ')
    //                 _classname.splice(_classname.indexOf("loading-parent--relative"), 1)
    //                 el.className = _classname.join(' ')
    //             }
    //         }, { default: () => child })
    //         if(binding.value){
    //             var _classname = el.className.split(' ')
    //             _classname.push('loading-parent--relative')
    //             el.className = _classname.join(' ')
    //             render(el.transition(el.loading(vnode)), el)
    //         }
    //     },
    //     updated(el, binding, vnode) {
    //         if(binding.value){
    //             var _classname = el.className.split(' ')
    //             _classname.push('loading-parent--relative')
    //             el.className = _classname.join(' ')
    //             render(el.transition(el.loading(vnode)), el)
    //         } else {
    //             render(el.transition(null), el)
    //         }
    //     },
    //     unmounted(el) {
    //         el.transition = null
    //         el.loading = null
    //     }
    // });
}
